import TreePicker from './TreePicker';
import withLocale from '../IntlProvider/withLocale';
export default withLocale(['Picker'])(TreePicker);